
import React, { Component } from "react";
import { Tabs } from 'antd';
import '../css/widget/widget.label.select.css'

const {TabPane} = Tabs;

class WidgetLabelSelect extends Component {
    constructor (props) {
        super(props);

        this.state = {
            value:props.value,
        }
    }

    active = (value) =>{

        this.setState({value:value});

        if(this.props.onChange)
        {
            this.props.onChange(value)
        }
    }

    checkAll = () => {

        this.setState({value:"all-label"});

        if( this.props.onChange )
        {
            this.props.onChange()
        }
    }

    componentWillReceiveProps( nextProps )
    {
        this.setState({value:nextProps.value});
    }

    render() 
    {
        const { value="all-label" } = this.state

        const {data=[], title, isTitleSelect } = this.props;

        return (
            <div className="sf-label-select sd-label-select sg-label-select">
                {
                    title ? 
                        <div className="sf-label-select-title sd-label-select-title sg-label-select-title"> 
                        {
                            isTitleSelect ? 
                                <><span> {title }: </span> <label className={ value==="all-label" ? "sf-title-label active" : "sf-title-label" } onClick={this.checkAll}> 全部 </label></> 
                                : <span> {title } </span>
                        }
                        </div> 
                        : <></>
                }
                <div className="sf-label-select-content">
                    <ul className="sf-label-select-ul">
                    {
                        data.map( (item, index) => {
                            return (
                                <li key={ item.value + index} onClick={()=>this.active(item.value)} className={ value===item.value? 'sf-label-item active' : 'sf-label-item'}>
                                    {item.label}
                                </li>
                            )
                        })
                    }
                    </ul>
                </div>
            </div>
        )
    }
}

export default WidgetLabelSelect;